/**
 * Display name for a saved community post in the media library (`users/{uid}.files[].name`).
 * Matches the composer header: combined "Post as" line (`postContent`, including segmented EVENT/CREW/… text),
 * then location if there is no body text.
 */

export const COMMUNITY_POST_FILE_NAME_MAX = 60;

/**
 * @param {object|null|undefined} postLike - `file.data`, a community list entity, or a `communityPosts` doc
 * @returns {string}
 */
export function deriveCommunityPostFileName(postLike) {
  if (!postLike || typeof postLike !== 'object') return 'Community Post';
  const content = String(postLike.postContent ?? '').trim();
  const loc = String(postLike.location ?? '').trim();
  const base = content || loc || 'Post';
  const sliced = base.slice(0, COMMUNITY_POST_FILE_NAME_MAX);
  return sliced || 'Community Post';
}

/** True when the library row label should be replaced with {@link deriveCommunityPostFileName}. */
export function communityPostFileNameNeedsBackfill(name) {
  const n = String(name ?? '').trim();
  if (!n) return true;
  if (n === 'Post' || n === 'Community Post') return true;
  return false;
}
